import type { ReactNode } from "react";

type WorkspaceListProps = {
  title: string;
  description?: string;
  toolbar?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
};

export function WorkspaceList({
  title,
  description,
  toolbar,
  children,
  footer,
}: WorkspaceListProps) {
  return (
    <div className="flex h-full min-h-[42rem] flex-col">
      <header className="border-b border-slate-200 bg-white p-5">
        <h2 className="text-lg font-semibold text-slate-950">
          {title}
        </h2>

        {description && (
          <p className="mt-1 text-sm leading-6 text-slate-500">
            {description}
          </p>
        )}

        {toolbar && <div className="mt-4">{toolbar}</div>}
      </header>

      <div className="min-h-0 flex-1 overflow-y-auto">
        {children}
      </div>

      {footer && (
        <footer className="border-t border-slate-200 bg-white p-4">
          {footer}
        </footer>
      )}
    </div>
  );
}